import AxiosInterceptor from "../../AxiosInterceptorMomthera";

// 환자 메시지 이력 조회
// request data
//  - pid
//  - text
//  - start
//  - end
export function getMessageFromMomthera(request) {
    return AxiosInterceptor({
        url: '/messages',
        method: 'get',
        params: request
    })
}

// 환자 메시지 발송
export function postMessageToMomthera(request) {
    return AxiosInterceptor({
        url: '/messages',
        method: 'post',
        data: request
    })
}

// 간편문구 조회
export function getMessagesTemplateFromMomthera() {
    return AxiosInterceptor({
        url: '/messages/template',
        method: 'get'
    })
}